import { createElement } from 'rax';
import EmbedYearPicker from '../embed-picker/year-picker';
import BaseRangePicker from './base-range-picker';
import { withLocale } from '../../locale';
class YearRangePicker extends BaseRangePicker {
    get rangeType() {
        return 'year';
    }
    renderFirstChild(value, validRange, onChange) {
        return this.renderBase(value, validRange, onChange);
    }
    renderSecondChild(value, validRange, onChange) {
        return this.renderBase(value, validRange, onChange);
    }
    renderBase(value, validRange, onChange) {
        return <EmbedYearPicker value={value} validRange={validRange} onChange={onChange}/>;
    }
    get format() {
        return this.props.format || 'YYYY';
    }
}
export default withLocale(YearRangePicker, {
    name: 'YearRangePicker',
    defaultLocale: {
        ok: '',
        cancel: '',
        prev: '上一步',
        next: '下一步',
        selectStartTime: '选择开始日期',
        selectEndTime: '选择结束日期',
    },
});
